import {
	type PartnerLevel,
	patchPartnersIdVerticalsVerticalIdLevel,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNER_DETAIL } from "Partner/Api/Query/usePartnerByIdQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const useUpdatePartnerVerticalLevel = (partnerId: number) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			({ verticalId, level }: { verticalId: number; level: PartnerLevel }) =>
				patchPartnersIdVerticalsVerticalIdLevel(
					{ level },
					partnerId,
					verticalId,
				),
		),
		onError: (error) => {
			console.error("Failed to update partner level:", error);
			toast.error("Failed to update partner level");
		},
		onSuccess: () => {
			toast.success("Partner level updated successfully");
			queryClient.invalidateQueries({
				queryKey: [PARTNER_DETAIL, partnerId],
			});
		},
	});
};
